import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  CreateUserRequest,
  PagedUsersResponse,
  UpdateUserRequest,
  User,
} from '../models/user.models';
import { UsersApiService } from './users-api.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly usersApiService = inject(UsersApiService);

  getUsers(
    companyId: number,
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    roleId?: number,
    isActive?: boolean,
  ): Observable<ApiResponse<PagedUsersResponse>> {
    return this.usersApiService.getUsers(companyId, pageNumber, pageSize, search, roleId, isActive);
  }

  getUser(userId: number): Observable<ApiResponse<User>> {
    return this.usersApiService.getUser(userId);
  }

  createUser(payload: CreateUserRequest): Observable<ApiResponse<User>> {
    return this.usersApiService.createUser(payload);
  }

  updateUser(userId: number, payload: UpdateUserRequest): Observable<ApiResponse<User>> {
    return this.usersApiService.updateUser(userId, payload);
  }

  deleteUser(userId: number): Observable<ApiResponse<string>> {
    return this.usersApiService.deleteUser(userId);
  }

  resetUserPassword(userId: number): Observable<ApiResponse<string>> {
    return this.usersApiService.resetUserPassword(userId);
  }
}
